import React, { useEffect, useState } from 'react'
import '../../ApplicationsDashboard/ApplicationsDashboard.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getQueryManagementReport } from '../../../redux/ReportsReducer/action';
import DownloadReport from '../DownloadReport';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import FilterModal from '../FilterModal/FilterModal';
import FunnelIconSvg from '../../../components/SVG/FunnelIconSvg';
import { REPORTS_COMPONENTS } from '../../../config/reports';
import { isAuthorised } from '../../../utils/common';
import { downloadReport, resetFilters } from '../../../utils/reportUtils';
import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
import Sidebar from '../../../components/Sidebar/Sidebar';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { getAllTaskStatuses } from '../../../redux/TaskReducer/action';
import { STATUS_FILTERS } from '../../../utils/taskUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { getAuthToken } from "../../../utils/auth";

const QueryManagementReport = () => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    const { queryManagementReport, pagination, officerProfile, taskStatuses } = useSelector((store) => {
        return {
            queryManagementReport: store.ReportsReducer.queryManagementReport.data,
            pagination: store.ReportsReducer.queryManagementReport.pagination,
            officerProfile: store.UserReducer.officerProfile,
            taskStatuses: store.TasksReducer.taskStatuses,
        }
    }, []);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [taskStatusFilters, setTaskStatusFilters] = useState(STATUS_FILTERS);
    const [isDownloading, setIsDownloading] = useState(false);

    const storedFilters = JSON.parse(sessionStorage.getItem('queryManagementFilters')) || {};

    const [queryManagementFilters, setQueryManagementFilters] = useState({
        customer_name: storedFilters?.customer_name || "",
        application_id: storedFilters?.application_id || "",
        branch_name: storedFilters?.branch_name || "",
        assigned_to_name: storedFilters?.assigned_to_name || "",
        created_by_name: storedFilters?.created_by_name || "",
        status_name: storedFilters?.status_name || "",
        priority: storedFilters?.priority || "",
        query_type: storedFilters?.query_type || "",
        sla_breach: storedFilters?.sla_breach || "",
        created_from: storedFilters?.created_from || "",
        created_to: storedFilters?.created_to || "",
        sort_by: storedFilters?.sort_by || "",
        sort_order: storedFilters?.sort_order || "",
        global_search: storedFilters?.global_search || ""
    });

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('reportsCurrentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('reportsLimit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('reportsTotalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    const [creationDateRange, setCreationDateRange] = useState([
        queryManagementFilters?.created_from ? new Date(queryManagementFilters.crea?.created_from) : null,
        queryManagementFilters?.created_to ? new Date(queryManagementFilters.created_to) : null,
    ]);

    const [creationStartDate, creationEndDate] = creationDateRange;

    useEffect(() => {
        dispatch(getQueryManagementReport(currentPage, limit, queryManagementFilters, null));

        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
        sessionStorage.setItem('queryManagementFilters', JSON.stringify(queryManagementFilters));
        // }, [dispatch, limit, currentPage, paymentTransactionFilters]);
    }, [dispatch, limit, currentPage]);

    useEffect(() => {
        dispatch(getAllTaskStatuses(taskStatusFilters));
    }, [taskStatusFilters]);

    useEffect(() => {
        return () => {
            sessionStorage.removeItem("queryManagementFilters");
            sessionStorage.removeItem("reportsCurrentPage");
            sessionStorage.removeItem("reportsLimit");
            sessionStorage.removeItem("reportsTotalPages");
            sessionStorage.removeItem("reportsTotalCount");
        };
    }, []);

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('reportsCurrentPage', pageToSet.toString());
    };

    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleDateRangeChange = (update, dateType) => {
        let updatedFilters;
        if (dateType === "creation") {
            setCreationDateRange(update);

            const [start, end] = update;

            updatedFilters = {
                ...queryManagementFilters,
                creation_start_date: formatDate(start),
                creation_end_date: formatDate(end),
            };
        }

        setQueryManagementFilters(updatedFilters);
        sessionStorage.setItem("queryManagementFilters", JSON.stringify(updatedFilters));
    };

    const handleFilterChange = (e) => {
        let { name, value } = e.target;

        if (typeof value === 'string') {
            value = value.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
        }

        let updatedFilters = {
            ...queryManagementFilters,
            [name]: value
        };

        setQueryManagementFilters(updatedFilters);
        sessionStorage.setItem("queryManagementFilters", JSON.stringify(updatedFilters));
    }

    useEffect(() => {
        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
    }, [limit, currentPage]);

    return (
        <>
            <div className="reportsDashboardContainer">
                <div className="reportsDashboard">
                    <Sidebar />

                    <div className="dashboardMainContent">
                        <div className="contentHeader">
                            <div className="userLogo">
                                <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                            </div>
                            <div className="headerRightPanel">
                                <UserProfileDropdown />
                            </div>
                        </div>

                        <div className="pageContentWrapper">
                            <div className="pageHeaderSection">
                                <Breadcrumb items={[
                                    { label: 'Admin' },
                                    { label: 'Reports', onClick: () => navigate('/reports') },
                                    { label: 'Query Management' }
                                ]} />

                                <div className="pageActions">
                                    <h2>Query Management</h2>
                                </div>
                            </div>

                            <div className="searchControlSection">
                                <div className="searchGroup">
                                    {isAuthorised(
                                        officerProfile,
                                        REPORTS_COMPONENTS['query-management_search']
                                    ) && <div className="tableSearchBar">
                                            <input
                                                type="search"
                                                placeholder="Search by subtask id, title, customer name, application id, query type, assigned officer name, created by name"
                                                name="global_search"
                                                value={queryManagementFilters?.global_search}
                                                onChange={handleFilterChange}
                                                onInput={(e) => {
                                                    if (e.target.value === "") {
                                                        let updatedFilters = {
                                                            ...queryManagementFilters,
                                                            global_search: e.target.value
                                                        }

                                                        setQueryManagementFilters(updatedFilters)

                                                        dispatch(getQueryManagementReport(1, limit, updatedFilters));
                                                    }
                                                }}
                                            />
                                        </div>}
                                    <div className="searchActionButtons">
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['query-management_search']
                                        ) && <button
                                            className="searchButton iconOnly"
                                            title="Search"
                                            onClick={() => {
                                                dispatch(getQueryManagementReport(1, limit, queryManagementFilters, null));
                                            }}
                                        >
                                                <FontAwesomeIcon icon={faSearch} />
                                            </button>}
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['query-management_download']
                                        ) && <button
                                            className="downloadButton"
                                            onClick={() => {
                                                downloadReport("query-management", queryManagementFilters, setIsDownloading);
                                            }}
                                            disabled={isDownloading}
                                        >
                                                {isDownloading ? (
                                                    <>
                                                        <span className="buttonSpinner"></span>
                                                        Downloading...
                                                    </>
                                                ) : (
                                                    <>
                                                        Download
                                                    </>
                                                )}
                                            </button>}
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['query-management_filters']
                                        ) && (
                                                <div className="filterPopoverWrapper">
                                                    <button
                                                        className="filterButton"
                                                        onClick={() => setShowFilterModal(!showFilterModal)}
                                                    >
                                                        <FunnelIconSvg fillColor={"black"} />
                                                    </button>
                                                    {showFilterModal && (
                                                        <FilterModal
                                                            reportTitle={"query-management"}
                                                            filters={queryManagementFilters}
                                                            setFilters={setQueryManagementFilters}
                                                            resetFilters={() => {
                                                                let resettedFilters = resetFilters(queryManagementFilters);

                                                                setQueryManagementFilters(resettedFilters);
                                                                dispatch(getQueryManagementReport(1, limit, resettedFilters, null));
                                                                handlePageChange(1);
                                                                setShowFilterModal(false);
                                                                sessionStorage.setItem("queryManagementFilters", JSON.stringify(resettedFilters));
                                                                return resettedFilters;
                                                            }}
                                                            handleApplyFilters={(finalFilters) => {
                                                                handlePageChange(1);
                                                                dispatch(getQueryManagementReport(1, limit, finalFilters, null));
                                                                setShowFilterModal(false);
                                                            }}
                                                            onClose={() => {
                                                                setShowFilterModal(false);
                                                            }}
                                                            dynamicOptions={{
                                                                status_name: taskStatuses?.map((status) => {
                                                                    return {
                                                                        label: status.status_name,
                                                                        value: status.status_code,
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>



                            <div className="tableCard">
                                <main className="">
                                    <div className="reportsTableContainer">
                                        <table className="applications-table" style={{ overflowX: "auto" }}>
                                            <thead>
                                                <tr>
                                                    <th>Sub Task ID</th>
                                                    <th>Readable Sub Task ID</th>
                                                    <th>Title</th>
                                                    <th>Readable Task ID</th>
                                                    <th>Application ID</th>
                                                    <th>Customer Name</th>
                                                    <th>Branch Name</th>
                                                    <th>Query type</th>
                                                    <th>Assigned To</th>
                                                    <th>Created By</th>
                                                    <th>Status</th>
                                                    <th>Priority</th>
                                                    <th>Creation Date</th>
                                                    <th>Start Date</th>
                                                    <th>Due Date</th>
                                                    <th>Completion Date</th>
                                                    <th>Aging Hours</th>
                                                    <th>Rejection Count</th>
                                                    <th>Last Action Date</th>
                                                    <th>Last Action By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    queryManagementReport?.length === 0 ?
                                                        <tr>
                                                            <td colSpan={12} className="no-data-cell">
                                                                No records found
                                                            </td>
                                                        </tr> :
                                                        queryManagementReport?.map((query, index) => (
                                                            <tr key={index}>
                                                                <td>{query?.sub_task_id}</td>
                                                                <td>{query?.readable_sub_task_id}</td>
                                                                <td>{query?.title}</td>
                                                                <td>{query?.readable_task_id}</td>
                                                                <td>{query?.application_id}</td>
                                                                <td>{query?.customer_name}</td>
                                                                <td>{query?.branch_name}</td>
                                                                <td>{query?.query_type}</td>
                                                                <td>{query?.assigned_to_name}</td>
                                                                <td>{query?.created_by_name}</td>
                                                                <td>{query?.status_name}</td>
                                                                <td>{query?.priority_name}</td>
                                                                <td>{query?.created_at?.split('T')?.[0]}</td>
                                                                <td>{query?.start_date?.split('T')?.[0]}</td>
                                                                <td>{query?.due_date?.split('T')?.[0]}</td>
                                                                <td>{query?.completed_at?.split('T')?.[0]}</td>
                                                                <td>{query?.aging_hours}</td>
                                                                <td>{query?.rejection_count}</td>
                                                                <td>{query?.last_action_date?.split('T')?.[0]}</td>
                                                                <td>{query?.last_action_by}</td>
                                                            </tr>
                                                        ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {queryManagementReport?.length > 0 && <div className="paginationControls">
                                        <CustomPagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>}
                                </main>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                showDownloadModal && (
                    <DownloadReport
                        isOpen={showDownloadModal}
                        onClose={() => setShowDownloadModal(false)}
                        reportTitle={"query-management"}
                    />
                )
            }
        </>
    )
}

export default QueryManagementReport